module.exports = __webpack_public_path__ + "img/gffs.8bca47fd.gif";